import CrudRepository from './CrudRepository'
import Repository from './Repository'
import Store from '../store'
export default class BundleSliderRepository extends CrudRepository {
  constructor () {
    super('core/api/bundles/popular/web')
  }

  async getPage (page, size) {
    const gsm = Store.state.selectedNumber
    const data = await Repository.get(`${this.resource}?page=${page}&size=${size}${gsm !== null ? `&gsm=${gsm}` : ''}`)
    return data.data
  }
}
